import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';

// Component use in Both HomeContainer and EAPHome
const EAPSection = ({ eapCards }) => {
  const history = useHistory();
  if (!eapCards) return null; // Handle case where eapCards is not provided
  // Determine grid classes based on gridColumn value
  const getGridClasses = (gridColumn, gridlayout) => {
    if (!gridlayout) return ''; // No grid if gridLayout is false

    switch (gridColumn) {
      case 1:
        return 'w-full grid grid-cols-1 gap-2';
      case 2:
        return 'w-full grid grid-cols-2 gap-2';
      case 3:
        return 'w-full grid grid-cols-3 gap-2';
      default:
        return 'w-full grid grid-cols-1 gap-2';
    }
  };

  const gridClasses = getGridClasses(
    eapCards?.gridColumn,
    eapCards?.gridlayout
  );

  const handleCardClick = (card) => {
    switch (card?.cardType) {
      case 'mood-journal-program':
      case 'mood-program': {
        history.push('/mood-journal/home');
        break;
      }
      case 'meditation-program': {
        history.push('/health-content/podcasts-home');
        break;
      }
      case 'yoga-card':
      case 'yoga-program': {
        history.push('/health-content/fitness-home');
        break;
      }
      case 'professional-program': {
        history.push(
          `/consultation/doctor-select?verticalId=${card.verticalId}`
        );
        break;
      }
      case 'see-all-program': {
        history.push(`/eap/home`);
        break;
      }
      default:
        return null;
    }
  };

  return (
    <div
      className="w-full p-4 border-b border-txtsecondary-shades4 "
      style={{ borderBottomWidth: '10px' }}
    >
      {eapCards?.showTitle && (
        <div className="text-title-m font-bold mb-16px">{eapCards.title}</div>
      )}
      <div className={gridClasses}>
        {eapCards?.cards?.map((card, index) => (
          <div
            key={index}
            className="bg-white flex flex-col items-center w-full clickable overflow-hidden"
            onClick={() => handleCardClick(card)}
          >
            <div className="px-12px">
              <img src={card.imageUrl} className="flex-shrink-0 mx-auto " />
            </div>
            <h3 className="text-body-s font-medium text-txtsecondary mt-1 text-center whitespace-normal">
              {card.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(EAPSection);
